module.exports = __webpack_public_path__ + "static/media/partner.c613f452.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/intro/partner.png
// module id = 809
// module chunks = 0